module.exports = __webpack_public_path__ + "static/img/new_logo_7.fded88e2.png";